import { StatusTagProps } from "@portal/BaseComponents/Table/Components/StatusTag/StatusTag";
import { FileList } from "@portal/BaseComponents/Upload/type";
import { Files } from "../file";
import { MultiCurrencySplit } from "../multi-currency";
import { BASE_QUERY_PARAMS } from "./../app-query-params";
import { AssociatedInvoice, InvoiceLineItem } from "./invoice";
import { SourceApp } from "./source-app";
import { UserUI_DV_DTO } from "./user";
const disputes_sort_col = [
  "DEFAULT",
  "ID",
  "TITLE",
  "DISPUTE_DATE",
  "AMOUNT",
  "CLOSED_DATE",
] as const;

export type DisputeSortCol = (typeof disputes_sort_col)[number];

export type DisputeViews = "ALL" | "OPEN" | "WAITING_ON_CUSTOMER" | "CLOSED";
export type DisputeStatus = Exclude<DisputeViews, "ALL">;

export const disputeFiledIds = {
  invoice_ids: "invoice_ids",
  dispute_type_ids: "dispute_type_ids",
  title: "title",
  description: "description",
  invoice_line_item_ids: "invoice_line_item_ids",
  file_upload_ids: "file_upload_ids",
  status: "status",
} as const;


export interface DisputeParams {
  include_archived: boolean;
}
export interface CreateDispute {
  [disputeFiledIds.invoice_ids]: string[];
  [disputeFiledIds.dispute_type_ids]: string[];
  [disputeFiledIds.title]: string;
  [disputeFiledIds.description]?: string;
  [disputeFiledIds.file_upload_ids]?: string[];
  [disputeFiledIds.invoice_line_item_ids]?: string[];
  [disputeFiledIds.status]?: DisputeStatus;
}

export interface CreateDisputeForm
  extends Omit<CreateDispute, "file_upload_ids"> {
  [disputeFiledIds.file_upload_ids]?: FileList<Files>;
}
export type DisputeConfigs = {
  [key in DisputeStatus]: {
    label: string;
    style: StatusTagProps["style"];
  };
};
export interface DisputeOwners extends UserUI_DV_DTO {}
export interface DisputeCreatedBy extends UserUI_DV_DTO {}
export interface DisputeClosedBy extends UserUI_DV_DTO {}
export interface DisputeTypes {
  id: string;
  name: string;
  archived?: true | false;
}

export interface DisputeList {
  id: string;
  description?: string;
  created_at: string;
  title: string;
  status: DisputeStatus;
  resolved_at?: string;
  dispute_types: DisputeTypes[];
  invoices: AssociatedInvoice[];
  amount: MultiCurrencySplit;
  created_by: DisputeCreatedBy;
  participants: DisputeCreatedBy;
  updated_at: string;
  updated_by: DisputeCreatedBy;
}

export interface InvoiceDispute {
  id: string;
  amount: number;
  amount_base_currency: number;
}

export interface DisputeDetails {
  id: string;
  description: string;
  dispute_date: string;
  title: string;
  status: DisputeStatus;
  participants: DisputeOwners[];
  dispute_types: DisputeTypes[];
  invoices: AssociatedInvoice[];
  created_by: DisputeCreatedBy;
  closed_by?: DisputeClosedBy;
  attachments: Files[];
  source_app: SourceApp;
  resolved_at?: string;
  amount: MultiCurrencySplit;
  invoice_line_items: Array<InvoiceLineItem>;
  created_at: string;
  updated_at: string;
}

export interface DISPUTE_QUERY_PARAMS extends BASE_QUERY_PARAMS {
  invoice_ids: string | null;
}
